import React, { useEffect, useState } from 'react';
import { LayoutCard } from './list-admin-feedback-requests.styles';
import { ListAdminFeedbackRequestsProps } from './types';
import { PaginationLayout } from '@shared/ui/pagination-layout/pagination-layout';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { useFeedbackRequestListSharedQuery } from '@entities/feedback-request/libs/hooks/use-feedback-request-list-shared-query/use-feedback-request-list-shared-query';
import { CardFeedbackRequest } from '@entities/feedback-request/ui/card-feedback-request/card-feedback-request';
import { FeedbackRequestChangeStatus } from '@features/feedback-request/feedback-request-change-status/ui/feedback-request-change-status';
import { useFeedbackRequestDetailSharedQuery } from '@entities/feedback-request/libs/hooks/use-feedback-request-detail-shared-query/use-feedback-request-detail-shared-query';
import { ModalFeedbackRequestView } from '@features/feedback-request/feedback-request-change-status/ui/modal-feedback-request-view/modal-feedback-request-view';
import { FeedbackRequestsSort } from '@features/feedback-request/feedback-request-sort/ui/feedback-request-sort';
import { useHistory, useLocation } from 'react-router-dom';

export const ListAdminFeedbackRequests: React.FC<ListAdminFeedbackRequestsProps> = ({
    feedbackRequestsListParameters,
    setFeedbackRequestsListParameters,
}) => {
    const { pathname, search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const history = useHistory();

    const [isFeedbackRequestView, setIsFeedbackRequestView] = useState<number | null>(null);
    const [, getFeedbackRequestsListResult] = useFeedbackRequestListSharedQuery(feedbackRequestsListParameters);
    const [getFeedbackRequestDetail] = useFeedbackRequestDetailSharedQuery();

    const isLoading =
        getFeedbackRequestsListResult.isLoading ||
        getFeedbackRequestsListResult.isFetching ||
        getFeedbackRequestsListResult.isUninitialized;

    const handleFeedbackModal = (id?: number | null) => {
        id ? searchParams.set('id', String(id)) : searchParams.delete('id');
        history.push(`${pathname}?${searchParams.toString()}`);
    };

    useEffect(() => {
        setIsFeedbackRequestView(Number(searchParams.get('id')));
    }, [search]);

    return (
        <>
            <PaginationLayout
                listLength={getFeedbackRequestsListResult.data?.total || 0}
                isLoading={isLoading}
                parameters={feedbackRequestsListParameters}
                setParameters={setFeedbackRequestsListParameters}>
                <LayoutCard>
                    <FeedbackRequestsSort
                        parameters={feedbackRequestsListParameters}
                        setParameters={setFeedbackRequestsListParameters}
                    />
                    <NetworkStateNew
                        isLoading={isLoading}
                        isError={getFeedbackRequestsListResult.isError}
                        isInitialized={Boolean(getFeedbackRequestsListResult.data)}
                        isFiltered={Boolean(getFeedbackRequestsListResult.data?.search)}
                        hasData={Boolean(getFeedbackRequestsListResult.data?.items.length)}
                        errorProps={{
                            title: 'Ошибка загрузки обращений',
                            description: getQueryError(getFeedbackRequestsListResult)?.message,
                        }}
                        emptyProps={{
                            title: 'Обращения отсутствуют',
                        }}
                        emptyFilteredProps={{
                            title: 'Обращения не найдены',
                        }}
                        updateLoaderProps={{
                            style: { left: 20, right: 20 },
                        }}>
                        {getFeedbackRequestsListResult.data?.items.map((feedbackRequest) => (
                            <CardFeedbackRequest
                                key={feedbackRequest.id}
                                feedbackRequest={feedbackRequest}
                                onClick={() => handleFeedbackModal(feedbackRequest.id)}
                                onMouseDown={() => getFeedbackRequestDetail(feedbackRequest.id)}>
                                <FeedbackRequestChangeStatus feedbackRequest={feedbackRequest} />
                            </CardFeedbackRequest>
                        ))}
                    </NetworkStateNew>
                </LayoutCard>
            </PaginationLayout>
            <ModalFeedbackRequestView
                isShow={Boolean(isFeedbackRequestView)}
                feedbackRequestId={Number(isFeedbackRequestView)}
                onClose={() => handleFeedbackModal(null)}
            />
        </>
    );
};
